// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Schedule = ({ fill, svgComponents: { Circle, G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M32.06,36.39H7.94A4,4,0,0,1,4,32.45V11.78A4,4,0,0,1,7.94,7.83H32.06A4,4,0,0,1,36,11.78V32.45A4,4,0,0,1,32.06,36.39ZM7.94,8.83A3,3,0,0,0,5,11.78V32.45a3,3,0,0,0,2.94,2.94H32.06A3,3,0,0,0,35,32.45V11.78a3,3,0,0,0-2.94-2.94Z" />
            <Path d="M35.5,19.83H4.5a.5.5,0,0,1,0-1h31a.5.5,0,0,1,0,1Z" />
            <Path d="M12.26,14.61a.5.5,0,0,1-.5-.5V5.67a.5.5,0,0,1,1,0v8.44A.5.5,0,0,1,12.26,14.61Z" />
            <Path d="M27.75,14.61a.5.5,0,0,1-.5-.5V5.67a.5.5,0,0,1,1,0v8.44A.5.5,0,0,1,27.75,14.61Z" />
            <Circle cx="12.26" cy="14.47" r="2.5" />
            <Circle cx="27.75" cy="14.47" r="2.5" />
        </G>
    );
};

export default Schedule;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/schedule/index.js